const e = "_container_1mue9_5", c = "_disabled_1mue9_11", t = "_thumb_1mue9_24", _ = "_checked_1mue9_35", s = {
  container: e,
  disabled: c,
  switch: "_switch_1mue9_15",
  thumb: t,
  checked: _
};
export {
  _ as checked,
  e as container,
  s as default,
  c as disabled,
  t as thumb
};
//# sourceMappingURL=index.es2396.js.map
